document.addEventListener('DOMContentLoaded', function () {
  var menuBtn = document.getElementById('minusMobileMenuBtn');
  var closeBtn = document.getElementById('minusDrawerCloseBtn');
  var drawer = document.getElementById('minusMobileDrawer');
  var overlay = document.getElementById('minusDrawerOverlay');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.classList.add('minus-drawer-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.classList.remove('minus-drawer-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-minus-cart-trigger]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      var cartBubble = document.getElementById('cart-icon-bubble');
      var cartType = el.getAttribute('data-cart-type');
      if (cartBubble && cartType === 'drawer') {
        event.preventDefault();
        cartBubble.click();
      }
    });
  });
});
